/**
 * Consulta CEP via ViaCEP (primario) com fallback BrasilAPI.
 * APIs publicas e gratuitas, sem chave de autenticacao.
 */

export function normalizeCep(value) {
  return String(value || '').replace(/\D/g, '').slice(0, 8);
}

export function formatCepDisplay(value) {
  const digits = normalizeCep(value);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

function mapViaCep(data) {
  if (!data || data.erro) return null;
  return {
    endereco: (data.logradouro || '').trim(),
    bairro: (data.bairro || '').trim(),
    cidade: (data.localidade || '').trim(),
    estado: (data.uf || '').trim().toUpperCase(),
  };
}

function mapBrasilApi(data) {
  if (!data) return null;
  return {
    endereco: (data.street || '').trim(),
    bairro: (data.neighborhood || '').trim(),
    cidade: (data.city || '').trim(),
    estado: (data.state || '').trim().toUpperCase(),
  };
}

async function fetchViaCep(digits) {
  const res = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
  if (!res.ok) return null;
  const data = await res.json();
  return mapViaCep(data);
}

async function fetchBrasilApi(digits) {
  const res = await fetch(`https://brasilapi.com.br/api/cep/v1/${digits}`);
  if (!res.ok) return null;
  const data = await res.json();
  return mapBrasilApi(data);
}

export async function fetchEnderecoPorCep(cep) {
  const digits = normalizeCep(cep);
  if (digits.length !== 8) return null;

  try {
    const via = await fetchViaCep(digits);
    if (via) return via;
  } catch {
    /* fallback */
  }

  try {
    return await fetchBrasilApi(digits);
  } catch {
    return null;
  }
}

export const CEP_FIELD_NAMES = {
  cep: 'cep',
  endereco: 'endereco',
  bairro: 'bairro',
  cidade: 'cidade',
  estado: 'estado',
};
